import { render, staticRenderFns } from "./governance.vue?vue&type=template&id=2df2d04a&scoped=true"
import script from "./governance.vue?vue&type=script&lang=js"
export * from "./governance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df2d04a",
  null
  
)

export default component.exports